import { useMemo } from 'react';
import { PageUrl } from '../pages/utils/page-url';
import { CustomPreference } from '../utils/api/CustomPreference';
import { useABTestVariable } from './useABTestVariable';

export const useSearchUrl = (): string => {
    const pwaSearchMode = useABTestVariable<string>(CustomPreference.PWA_SEARCH_MODE, 'SFCC');
    const searchUrl: string = useMemo(
        () => (pwaSearchMode === 'PWA_SEARCH_PREFIXED' ? PageUrl.PWA_SEARCH : PageUrl.SEARCH),
        [pwaSearchMode],
    );
    return searchUrl;
};
